import Axios from 'axios';

export default Axios.create({ baseURL: 'https://flex-api.sharetribe.com/v1/' });
